import sojiLogo from '../../assets/soji_logo.svg';
import Image404 from '../../assets/404_img.svg';
import { BasicButton } from '../../component/button';
import styled from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../component/colors';

export const Page404 = () => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <Navbar>
        <SojiLogo src={sojiLogo} />
      </Navbar>
      <Container>
        <OppsText>Oops!</OppsText>
        <FlexBox>
          <StyledImage404 src={Image404} />
          <Div>
            <ErrorText>
              The page you are looking for is not available or might have been
              removed
            </ErrorText>
            <Redirectiontex>
              You can click the button below to go back to the home page
            </Redirectiontex>
            <HomeButton onClick={() => navigate('dashboard/home')}>
              Home
            </HomeButton>
          </Div>
        </FlexBox>
      </Container>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  background-color: #fafafb;
`;
const Navbar = styled.div`
  padding: 20px 50px;
  @media screen and (max-width: 600px) {
    background: ${colors.white};
    filter: drop-shadow(0px 4px 4px rgba(50, 50, 71, 0.05));
    padding: 40px 20px 24px 20px;
  }
`;
const SojiLogo = styled.img`
  @media screen and (max-width: 600px) {
    width: 60px;
    height: 32px;
  }
`;
const Container = styled.div`
  padding: 0px 50px 50px 50px;
  @media screen and (max-width: 600px) {
    text-align: center;
    padding: 0px 20px;
  }
`;
const OppsText = styled.h1`
  font-weight: 700;
  font-size: ${pxToRem(96)};
  line-height: ${pxToRem(144)};
  color: ${colors.textDarkAlt};
  margin: 70px 0px 30px 0px;
  @media screen and (max-width: 600px) {
    font-size: ${pxToRem(64)};
    margin: 50px 0px 0px 0px;
  }
`;
const StyledImage404 = styled.img`
  width: 50%;
  margin-top: -100px;
  @media screen and (max-width: 600px) {
    width: 100%;
    margin: 0px 0px 30px 0px;
  }
`;
const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-self: flex-start;
  height: 20vh;
  @media screen and (max-width: 600px) {
    display: block;
    height: 0vh;
  }
`;
const Div = styled.div`
  width: 50%;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;
const ErrorText = styled.p`
  font-weight: 500;
  font-size: ${pxToRem(24)};
  line-height: ${pxToRem(36)};
  color: ${colors.textDarkAlt};
  max-width: 469px;
  @media screen and (max-width: 600px) {
    font-size: ${pxToRem(20)};
    line-height: ${pxToRem(30)};
  }
`;
const Redirectiontex = styled.p`
  font-weight: 400;
  font-size: ${pxToRem(14)};
  line-height: ${pxToRem(21)};
  color: ${colors.textDarkAlt};
  margin: 12px 0px;
`;
const HomeButton = styled(BasicButton)`
  margin-top: 35px;
`;
